"use client";

import { c as _c } from "react/compiler-runtime";
import { IconChevronDownOutline18 } from "nucleo-ui-outline-18";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fromDateTimeLocalString, getDetailedCountdown, getRelativeTime, toDateTimeLocalString, toISODateTimeString } from "@/lib/utils/formatRelativeTime";
import { parseDate } from "chrono-node";
import { useEffect, useState } from "react";
interface DateTimeInputProps {
  label: string;
  description?: string;
  headerRight?: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
}
function formatDate(date: Date | undefined) {
  if (!date) {
    return "";
  }
  return date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
}
export default function DateTimeInput(t0) {
  const $ = _c(99);
  const {
    label,
    description,
    headerRight,
    value,
    onChange
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== value) {
    t1 = fromDateTimeLocalString(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [date, setDate] = useState(t1);
  let t2;
  if ($[2] !== date) {
    t2 = date || new Date();
    $[2] = date;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [month, setMonth] = useState(t2);
  const [inputValue, setInputValue] = useState(value || "");
  const [naturalLanguageInput, setNaturalLanguageInput] = useState("");
  const [relativeTime, setRelativeTime] = useState("");
  const [countdown, setCountdown] = useState("");
  let today;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    today = new Date();
    today.setHours(0, 0, 0, 0);
    $[4] = today;
  } else {
    today = $[4];
  }
  let t3;
  let t4;
  if ($[5] !== date) {
    t3 = () => {
      if (!date) {
        setRelativeTime("");
        setCountdown("");
        return;
      }
      const updateTime = () => {
        setRelativeTime(getRelativeTime(date));
        setCountdown(getDetailedCountdown(date));
      };
      updateTime();
      const interval = setInterval(updateTime, 1000);
      return () => clearInterval(interval);
    };
    t4 = [date];
    $[5] = date;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[8] !== date || $[9] !== value) {
    t5 = () => {
      const parsedDate = fromDateTimeLocalString(value);
      if (parsedDate && parsedDate.getTime() !== date?.getTime()) {
        setDate(parsedDate);
        setMonth(parsedDate);
        setInputValue(toDateTimeLocalString(parsedDate));
      }
    };
    t6 = [value, date];
    $[8] = date;
    $[9] = value;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] !== date || $[13] !== onChange) {
    t7 = selectedDate => {
      if (!selectedDate) {
        return;
      }
      const currentDate = date || new Date();
      selectedDate.setHours(currentDate.getHours());
      selectedDate.setMinutes(currentDate.getMinutes());
      setDate(selectedDate);
      setMonth(selectedDate);
      const displayValue = toDateTimeLocalString(selectedDate);
      setInputValue(displayValue);
      onChange(toISODateTimeString(selectedDate));
      setOpen(false);
      setNaturalLanguageInput(getRelativeTime(selectedDate));
    };
    $[12] = date;
    $[13] = onChange;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleDateSelect = t7;
  let t8;
  if ($[15] !== date || $[16] !== onChange) {
    t8 = timeValue => {
      if (!timeValue) {
        return;
      }
      const [hours, minutes] = timeValue.split(":").map(Number);
      const currentDate_0 = date || new Date();
      currentDate_0.setHours(hours);
      currentDate_0.setMinutes(minutes);
      const now = new Date();
      if (currentDate_0 < now) {}
      setDate(currentDate_0);
      const displayValue_0 = toDateTimeLocalString(currentDate_0);
      setInputValue(displayValue_0);
      onChange(toISODateTimeString(currentDate_0));
      setNaturalLanguageInput(getRelativeTime(currentDate_0));
    };
    $[15] = date;
    $[16] = onChange;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const handleTimeChange = t8;
  let t9;
  if ($[18] !== onChange) {
    t9 = newValue => {
      setInputValue(newValue);
      const parsedDate_0 = fromDateTimeLocalString(newValue);
      if (parsedDate_0) {
        setDate(parsedDate_0);
        setMonth(parsedDate_0);
        onChange(toISODateTimeString(parsedDate_0));
      }
    };
    $[18] = onChange;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const handleInputChange = t9;
  let t10;
  if ($[20] !== onChange) {
    t10 = text => {
      setNaturalLanguageInput(text);
      const parsedDate_1 = parseDate(text);
      if (parsedDate_1) {
        setDate(parsedDate_1);
        setMonth(parsedDate_1);
        const displayValue_1 = toDateTimeLocalString(parsedDate_1);
        setInputValue(displayValue_1);
        onChange(toISODateTimeString(parsedDate_1));
      }
    };
    $[20] = onChange;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const handleNaturalLanguageChange = t10;
  let t11;
  if ($[22] !== inputValue) {
    t11 = inputValue ? inputValue.split("T")[1] || "" : "";
    $[22] = inputValue;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const timeValue_0 = t11;
  let t12;
  if ($[24] !== date) {
    t12 = date && date.toDateString() === new Date().toDateString();
    $[24] = date;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const isToday = t12;
  const isPastDateTime = date && date < new Date();
  let t13;
  if ($[26] !== headerRight || $[27] !== label) {
    t13 = label && <div className="flex items-center justify-between gap-3 px-1"><Label htmlFor={`date-${label}`}>{label}</Label>{headerRight}</div>;
    $[26] = headerRight;
    $[27] = label;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== description) {
    t14 = description && <p className="text-ds-text-subtle dark:text-ds-text-disabled px-1 text-xs">{description}</p>;
    $[29] = description;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = `date-picker-${label}`;
  let t16;
  if ($[31] !== t15) {
    t16 = <Label htmlFor={t15} className="label-xs-caps px-1">Date</Label>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const t17 = `date-picker-${label}`;
  let t18;
  if ($[33] !== date) {
    t18 = date ? formatDate(date) : "Select date";
    $[33] = date;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconChevronDownOutline18 className="h-4 w-4" />;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t17 || $[37] !== t18) {
    t20 = <PopoverTrigger asChild={true}><Button variant="white" id={t17} className="w-full justify-between font-normal">{t18}{t19}</Button></PopoverTrigger>;
    $[36] = t17;
    $[37] = t18;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      before: today
    };
    t22 = new Date().getFullYear();
    $[39] = t21;
    $[40] = t22;
  } else {
    t21 = $[39];
    t22 = $[40];
  }
  let t23;
  if ($[41] !== date || $[42] !== handleDateSelect || $[43] !== month) {
    t23 = <PopoverContent className="w-auto overflow-hidden p-0" align="start"><Calendar mode="single" selected={date} captionLayout="dropdown" month={month} onMonthChange={setMonth} onSelect={handleDateSelect} disabled={t21} fromYear={t22} toYear={2050} /></PopoverContent>;
    $[41] = date;
    $[42] = handleDateSelect;
    $[43] = month;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== open || $[46] !== t20 || $[47] !== t23) {
    t24 = <Popover open={open} onOpenChange={setOpen}>{t20}{t23}</Popover>;
    $[45] = open;
    $[46] = t20;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t16 || $[50] !== t24) {
    t25 = <div className="flex flex-1 flex-col gap-3">{t16}{t24}</div>;
    $[49] = t16;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  const t26 = `time-picker-${label}`;
  let t27;
  if ($[52] !== t26) {
    t27 = <Label htmlFor={t26} className="label-xs-caps px-1">Time</Label>;
    $[52] = t26;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  const t28 = `time-picker-${label}`;
  let t29;
  if ($[54] !== handleTimeChange) {
    t29 = e => handleTimeChange(e.target.value);
    $[54] = handleTimeChange;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  const t30 = `bg-background w-32 appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none ${isPastDateTime ? "border-red-300 focus:border-red-500 focus:ring-red-500/20 dark:border-red-700" : ""}`;
  let t31;
  if ($[56] !== t28 || $[57] !== t29 || $[58] !== t30 || $[59] !== timeValue_0) {
    t31 = <Input type="time" id={t28} value={timeValue_0} onChange={t29} className={t30} />;
    $[56] = t28;
    $[57] = t29;
    $[58] = t30;
    $[59] = timeValue_0;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t27 || $[62] !== t31) {
    t32 = <div className="flex flex-col gap-3">{t27}{t31}</div>;
    $[61] = t27;
    $[62] = t31;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] !== t25 || $[65] !== t32) {
    t33 = <div className="flex gap-4">{t25}{t32}</div>;
    $[64] = t25;
    $[65] = t32;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  const t34 = `natural-${label}`;
  let t35;
  if ($[67] !== t34) {
    t35 = <Label htmlFor={t34} className="label-xs-caps px-1">Or type naturally</Label>;
    $[67] = t34;
    $[68] = t35;
  } else {
    t35 = $[68];
  }
  const t36 = `natural-${label}`;
  let t37;
  if ($[69] !== handleNaturalLanguageChange) {
    t37 = e_0 => handleNaturalLanguageChange(e_0.target.value);
    $[69] = handleNaturalLanguageChange;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== naturalLanguageInput || $[72] !== t36 || $[73] !== t37) {
    t38 = <Input id={t36} value={naturalLanguageInput} placeholder="Tomorrow at 5pm, in 2 days, next week..." className="bg-background" onChange={t37} />;
    $[71] = naturalLanguageInput;
    $[72] = t36;
    $[73] = t37;
    $[74] = t38;
  } else {
    t38 = $[74];
  }
  let t39;
  if ($[75] !== isToday) {
    t39 = isToday && <p className="label-xs px-1">Time must be in the future</p>;
    $[75] = isToday;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] !== t35 || $[78] !== t38 || $[79] !== t39) {
    t40 = <div className="flex flex-col gap-2">{t35}{t38}{t39}</div>;
    $[77] = t35;
    $[78] = t38;
    $[79] = t39;
    $[80] = t40;
  } else {
    t40 = $[80];
  }
  let t41;
  if ($[81] !== countdown || $[82] !== date || $[83] !== relativeTime || $[84] !== timeValue_0) {
    t41 = date && relativeTime && <div className={`mt-2 rounded-lg px-3 py-2 ${date < new Date() ? "bg-red-50 dark:bg-red-950/20" : "bg-blue-50 dark:bg-blue-950/20"}`}><p className={`text-sm ${date < new Date() ? "text-red-900 dark:text-red-200" : "text-blue-900 dark:text-blue-200"}`}><span className="font-medium">{date < new Date() ? `Scheduled ${relativeTime} (past date)` : `Triggers ${relativeTime}`}</span>{" "}<span className="opacity-80">on {formatDate(date)} at{" "}{timeValue_0 || date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit"
          })}{" "}{date.toLocaleTimeString("en-US", {
            timeZoneName: "short"
          }).split(" ").pop()}</span></p><p className={`mt-1 font-mono text-xs ${date < new Date() ? "text-red-700 dark:text-red-300" : "text-blue-700 dark:text-blue-300"}`}>{countdown || "Calculating..."}</p></div>;
    $[81] = countdown;
    $[82] = date;
    $[83] = relativeTime;
    $[84] = timeValue_0;
    $[85] = t41;
  } else {
    t41 = $[85];
  }
  const t42 = `date-${label}`;
  let t43;
  if ($[86] !== handleInputChange) {
    t43 = e_1 => handleInputChange(e_1.target.value);
    $[86] = handleInputChange;
    $[87] = t43;
  } else {
    t43 = $[87];
  }
  let t44;
  if ($[88] !== inputValue || $[89] !== t42 || $[90] !== t43) {
    t44 = <Input type="datetime-local" id={t42} value={inputValue} onChange={t43} className="hidden" />;
    $[88] = inputValue;
    $[89] = t42;
    $[90] = t43;
    $[91] = t44;
  } else {
    t44 = $[91];
  }
  let t45;
  if ($[92] !== t13 || $[93] !== t14 || $[94] !== t33 || $[95] !== t40 || $[96] !== t41 || $[97] !== t44) {
    t45 = <div className="flex flex-col gap-3">{t13}{t14}{t33}{t40}{t41}{t44}</div>;
    $[92] = t13;
    $[93] = t14;
    $[94] = t33;
    $[95] = t40;
    $[96] = t41;
    $[97] = t44;
    $[98] = t45;
  } else {
    t45 = $[98];
  }
  return t45;
}